import { m } from 'framer-motion';

import {
  variantesLista,
  variantesReveal,
  VIEWPORT_REVEAL,
} from '@/design/motion';

/**
 * Entrada escalonada na rolagem.
 *
 * `m` e não `motion`: o LazyMotion do MotionRoot roda em modo strict,
 * e `motion.*` arrastaria o bundle completo de volta.
 */
export const Reveal = ({ children, className = '', as = 'div', delay = 0 }) => {
  const Tag = m[as] ?? m.div;

  return (
    <Tag
      className={className}
      variants={variantesReveal}
      initial="oculto"
      whileInView="visivel"
      viewport={VIEWPORT_REVEAL}
      transition={{ delay }}
    >
      {children}
    </Tag>
  );
};

/** Container: os filhos <Reveal.Item> entram em sequência. */
export const RevealLista = ({ children, className = '', intervalo = 0.07 }) => (
  <m.div
    className={className}
    variants={variantesLista(intervalo)}
    initial="oculto"
    whileInView="visivel"
    viewport={VIEWPORT_REVEAL}
  >
    {children}
  </m.div>
);

export const RevealItem = ({ children, className = '' }) => (
  <m.div className={className} variants={variantesReveal}>
    {children}
  </m.div>
);

export default Reveal;
